import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { SystemCatalog } from "@graylog/server-api";
import { defaultOnError } from "util/conditional/onError";
const fetchEntityTitles = (entities) => SystemCatalog.getTitles({ entities });
const useEntityTitles = (entities) => {
  var _a, _b;
  const stableEntities = [...entities].sort((a, b) => a.id.localeCompare(b.id));
  const enabled = stableEntities.length > 0;
  const { data, isInitialLoading, isFetching, isError } = useQuery({
    queryKey: ["entity_titles", stableEntities],
    queryFn: () => defaultOnError(
      fetchEntityTitles(stableEntities),
      "Loading entity titles failed with status",
      "Could not load entity titles"
    ),
    enabled,
    placeholderData: keepPreviousData
  });
  const titlesById = {};
  ((_a = data == null ? void 0 : data.entities) != null ? _a : []).forEach((entry) => {
    titlesById[entry.id] = entry.title;
  });
  const notPermittedIds = new Set((_b = data == null ? void 0 : data.not_permitted_to_view) != null ? _b : []);
  return {
    titlesById,
    notPermittedIds,
    isInitialLoading,
    isFetching,
    isError
  };
};
export default useEntityTitles;
